import { render } from "./ShopRoom.vue?vue&type=template&id=affafa2a&ts=true"
import script from "./ShopRoom.vue?vue&type=script&lang=ts"
export * from "./ShopRoom.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__